import { useContext } from 'react'
import { SplitContext } from '@splitsoftware/splitio-react'

export default function useTreatment (treatmentName) {
  const { client } = useContext(SplitContext)
  return client.getTreatment(treatmentName)
}
